import * as React from 'react';

import { useReadOnly } from 'slate-react';

import { ClosedCaptioningIcon } from '@coursera/cds-icons';

import Button, { TOOLBAR_BUTTON_TYPES } from 'bundles/cml/editor/components/buttons/Button';

import _t from 'i18n!nls/cml';

export type Props = {
  onClick: () => void;
};

const CodeBlockNameButton = ({ onClick }: Props) => {
  const readonly = useReadOnly();

  return (
    <Button
      role="menuitem"
      disabled={readonly}
      onClick={onClick}
      title={_t('Accessibility name')}
      tooltipProps={{ placement: 'bottom' }}
      type={TOOLBAR_BUTTON_TYPES.menu}
    >
      <ClosedCaptioningIcon size="small" />
    </Button>
  );
};

export default CodeBlockNameButton;
